import axios from "axios";
import constants from "../constants/constants";
import { UNAUTHORIZED } from "../constants/statusCode";
import { clearSession } from "../utils/localSession";
import { showError } from "../utils/messageHelper";
import { refreshTokenAPI } from "./auth/api";
import constant from "../constants/constants";

const instance = axios.create({
    baseURL: constants.baseURL,
});

instance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const { response } = error;
        if (response.status === UNAUTHORIZED) {
            const isRefreshTokenFailed = response.request.responseURL.split("/").includes("refresh_token");
            if (isRefreshTokenFailed) {
                clearSession();
                window.location.href = process.env.PUBLIC_URL + "/login";
            } else if (localStorage.getItem("_refreshToken")) {
                const data = await refreshTokenAPI();
                if (data.status === UNAUTHORIZED) {
                    clearSession();
                    window.location.href = process.env.PUBLIC_URL + "/login";
                } else {
                    data?.data?.data?.access_token && localStorage.setItem(constant.localStorageSessionKey, data?.data?.data?.access_token);
                    localStorage.removeItem(constant.localStorageSessionRefreshTokenKey);
                    window.location.reload();
                }
            } else {
                clearSession();
                window.location.href = process.env.PUBLIC_URL + "/login";
            }
        }
        // showError(response.data.responseMessage);
        return error;
    }
);

export default instance;
